import AbstractIceContentController from '../../abstract/ice-content/controller';

const HELPERS = window.App.Utils.Helpers;
const processLoaderHide = 'process-loader__hide';
class Controller extends AbstractIceContentController {

    constructor(widget) {
        super(widget);
        this.init(widget);
    }

    init(widget) {
        App.PubSub.subscribe("loaderToShow",
            function (res) {
                const processLoader = document.getElementById("process-loader");
                const loaderAnimate = document.getElementById("process-loader__animate");
                processLoader.classList.remove(processLoaderHide);

                if (res === "submitting") {
                    HELPERS.disableScroll();
                    loaderAnimate.classList.add("spinner");
                    loaderAnimate.classList.remove("success");
                    loaderAnimate.classList.remove("error");
                } else if (res === "success") {
                    loaderAnimate.classList.add("success");
                    loaderAnimate.classList.remove("error");
                    loaderAnimate.classList.remove("spinner");
                } else if (res === "hide-quick-scroll") {
                    loaderAnimate.classList.remove("error");
                    loaderAnimate.classList.remove("spinner");
                    loaderAnimate.classList.remove("success");
                    processLoader.classList.add(processLoaderHide);
                    HELPERS.enableScroll();
                } else {
                    loaderAnimate.classList.remove("error");
                    loaderAnimate.classList.remove("spinner");
                    loaderAnimate.classList.remove("success");
                    processLoader.classList.add(processLoaderHide);
                    setTimeout(function () {
                        HELPERS.enableScroll();
                    }, 2000);
                }
            });
    }

}
export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-process-loader/scripts/controller.js